<template>
  <div>
    <v-layout align-center>
      <v-flex class="text-xs-center">
        <v-menu
          :nudge-right="30"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="date"
            label="Date"
            prepend-icon="event"
            readonly
          />
          <v-date-picker
            v-model="date"
            @input="search"
          />

        </v-menu>
      </v-flex>
    </v-layout>
    <!-- buttons for each type of thing to buy -->
    <div class="text-xs-center pa-4">
      <v-btn
        :to="{path: '/reserve/camping'}"
      >
        <v-icon left>fa-map</v-icon>Camping
      </v-btn>
      <v-btn
        :to="{path: '/reserve/parking'}"
      >
        <v-icon left>fa-car</v-icon>Parking
      </v-btn>
      <v-btn
        :to="{path: '/reserve/passes'}"
      >
        <v-icon left>fa-passport</v-icon>Non-Resident Fees
      </v-btn>
      <v-btn
        v-if="assertSetting('personReserve', 1)"
        :to="{path: '/reserve/other'}"
      >
        <v-icon left>fa-cart-plus</v-icon>Other
      </v-btn>
    </div>
  </div>
</template>
<script>
// import modules
import Datepicker from 'vuejs-datepicker'
// import vuex mapping
import { mapFields } from 'vuex-map-fields'
import { mapActions } from 'vuex'
// our new component
export default {
  components: {
    Datepicker
  },
  computed: {
    ...mapFields({
      date: 'facilities.searchCriteria.date',
      searching: 'facilities.searchCriteria.searching'
    })
  },
  methods: {
    ...mapActions({
      getCampsiteWeek: 'facilities/getCampsiteWeek'
    }),
    search (val) {
      this.searching = true
      this.getCampsiteWeek().then(() => {
        this.searching = false
      })
    }
  }
}
</script>
